module.exports = __webpack_public_path__ + "static/media/verdana-negrita-cursiva.89241231.ttf";